import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=1ee21150&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=1ee21150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee21150",
  null
  
)

export default component.exports